import { createSlice } from "@reduxjs/toolkit";

const initialContestsReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  // entities: [],
  exportData: [],
  usersReportlist: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const UsersReportSlice = createSlice({

  name: "allTimeUsersReport",
  initialState: initialContestsReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.usersReportlist = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    usersReportList: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.usersReportlist = action.payload.data;
      state.totalCount = action.payload.totalRecord;
    },
    usersReportExport: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.exportData = action.payload;
    },
  }
});
